import { useEffect, useRef, useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import { Nav, NavItem, NavLink, TabContent, Fade, TabPane } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { callApi } from "../../ApiHelper/ApiHelper";
import { MainFilterHandler } from "../../components/comman/MainFilterHandler";
import { apiUrl } from "../../ApiHelper/ApiUrl";
import ViewIcon from "../../components/Icons/ViewIcon";
import MainHeading from "../../components/comman/MainHeading";
import FilterComponent from "../../components/comman/FilterComponent";
import CommonTable from "../../components/comman/CommonTable";
import ConfirmModal from "../../components/comman/ConfirmModal";
import {
  saveActivePaymentOverdueTab,
  updateFiltersStates,
} from "../../store/actions/UserActions";
import { RoutesLink } from "../../ApiHelper/RoutesLink";
import { formatAmount } from "../../utility/CommonFunctions";

export default function PaymentOverview() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isFirstYearChange, setIsFirstYearChange] = useState(true);
  const ActiveTab = useSelector(
    (state) => state?.root?.activePaymentOverdueTab
  );
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    filterData: "",
    month: "",
    paymentTicketList: [],
    searchQuery: "",
    dueDay: ActiveTab,
    type: "AgainstPO",
    siteId: filterDetails?.siteId,
    siteList: [],
    companyList: [],
    companyIsLoading: false,
    isLoadingSite: false,
    isInitial: true,
  });
  const [isLoading, setIsLoading] = useState(false);
  const userDetails = useSelector((state) => state.root.userDetails);
  const [modal, setModal] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const timeoutId = useRef(null);

  const toggleModal = () => {
    setModal(!modal);
  };

  useEffect(() => {
    GetSiteList(filterDetails?.companyId);
  }, [filterDetails?.companyId]);

  useEffect(() => {
    if (filterDetails?.year) {
      GetPaymentTicket(filterDetails?.currentPage);
    }
  }, [
    filterDetails?.currentPage,
    ActiveTab,
    pageStates.searchQuery,
    filterDetails?.sortByDate,
    filterDetails?.year,
    filterDetails.pageSize,
    filterDetails?.siteId,
    filterDetails?.companyId,
    filterDetails?.vendorId,
    filterDetails?.orderBy,
    pageStates?.isInitial,
  ]);

  useEffect(() => {
    GetCompanyList();
  }, []);

  const GetPaymentTicket = (pageNo) => {
    let options = {
      method: "GET",
    };
    const filterData = {
      dueDay: pageStates?.dueDay,
      type: pageStates?.type,
      searchQuery: pageStates?.searchQuery,
      siteId: pageStates?.siteId,
      ...filterDetails,
    };
    const Url =
      `${apiUrl.get_payment_ticket}from=paymentOverview&` +
      MainFilterHandler(filterData);
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.paymentTicket?.map((item) => ({
          ...item,
          siteName: item?.site?.name,
          paymentDate: moment(item?.date).format("DD-MM-YYYY"),
          createdBy: item?.user?.name,
          paymentTicketStatus: item?.status,
          grandTotal: formatAmount(item?.totalAmount),
          vendorName: item?.purchase?.vendor?.name,
          expenseName:
            item?.paymentticketexpenseheads[0]?.expensehead?.name +
            `${item?.paymentticketexpenseheads?.length > 1
              ? ` + ${item?.paymentticketexpenseheads?.length - 1}`
              : ""
            }`,
          payTerms: item?.purchase?.paymentTerms,
          remaining: formatAmount(item?.remainingAmount),
          paidAmount: formatAmount(item?.totalAmount - item?.remainingAmount),
        }));
        setPageStates((pre) => ({
          ...pre,
          paymentTicketList: newData,
        }));
        dispatch(
          updateFiltersStates({
            count: res?.data?.pageInfo?.total,
            totalPages: res?.data?.pageInfo?.totalPages,
          })
        );
      }
    });
  };

  const GetCompanyList = (inputValue) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_company}${inputValue ? `?search=${inputValue}` : ""
        }`;
      let options = { method: "GET" };
      setPageStates((prev) => ({
        ...prev,
        companyIsLoading: true,
      }));
      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData = response?.data?.company.map((company) => ({
              value: company.id,
              label: company.name,
            }));

            setPageStates((prev) => ({
              ...prev,
              companyIsLoading: false,
              companyList: formattedData,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const toggleTab = (tab) => {
    dispatch(saveActivePaymentOverdueTab(tab));
    setPageStates((prev) => ({
      ...prev,
      dueDay: tab,
    }));
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        companyId: "",
        vendorId: "",
      })
    );
    if (pageStates?.siteList?.length == 0) {
      GetSiteList();
    }
  };

  const HandleView = (data) => {
    navigate(RoutesLink.payment_tickets_details + `/againstPo/${data?.id}`);
  };

  const HandleUpdate = (data) => {
    navigate(RoutesLink?.create_against_po, { state: { data: data } });
  };

  const HandleDelete = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.delete_payment_ticket + `?paymentTicketId=${selectedId}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        toggleModal("delete");
        GetPaymentTicket();
      } else {
        toast.error(response?.message);
        toggleModal("delete");
      }
    });
  };

  const ActionHandler = (data) => {
    setSelectedId(data?.id);
    toggleModal();
  };

  const TableHeading = [
    { value: "ticketNumber", label: "Ticket Number" },
    { value: "siteName", label: "Site Name" },
    { value: "paymentDate", label: "Date" },
    { value: "createdBy", label: "Created By" },
    { value: "vendorName", label: "vendor name" },
    { value: "grandTotal", label: "Total Amount" },
    { value: "remaining", label: "Payable  Amount" },
    { value: "dueDays", label: "Due Days" },
    { value: "paymentStatus", label: "Payment Status" },
    { value: "payTerms", label: "Payment Term" },
  ];

  const ActionData = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= filterDetails?.totalPages) {
      dispatch(
        updateFiltersStates({
          currentPage: PageNo,
        })
      );
    }
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 500);
  };

  const handleChangePageSize = (value) => {
    dispatch(
      updateFiltersStates({
        pageSize: value,
        currentPage: 1,
      })
    );
  };

  const dateChangeHandler = (Dates) => {
    // console.log(Dates);
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      dispatch(
        updateFiltersStates({
          sortByDate: formattedDate,
        })
      );
    } else {
      dispatch(
        updateFiltersStates({
          sortByDate: "",
        })
      );
    }
  };

  const GetSiteList = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      let API =
        userDetails?.type === 2
          ? apiUrl.get_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`
          : apiUrl.get_user_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`;

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item?.site?.id || item.id,
              label: item?.site?.name || item.name,
            }));

            const isSitePresent = response.data?.site?.some((item) => {
              const id = item?.site?.id || item.id;
              return id == filterDetails?.siteId;
            });

            setPageStates((prev) => ({
              ...prev,
              ...(isSitePresent ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const sortList = {
    site: pageStates?.siteList,
    isShow: "show",
    companyList: pageStates?.companyList,
  };

  const handleSortData = (data, type) => {
    setPageStates((prevState) => ({
      ...prevState,
      ...(type === "site" && { siteId: data?.site }),
      ...(type === "companyId" && { companyId: data?.companyId }),
      ...(type == "companyId" && {
        siteId: "",
      }),
    }));
    dispatch(
      updateFiltersStates({
        ...(type === "site" && { siteId: data?.site }),
        ...(type == "companyId" && { companyId: data?.companyId, siteId: "" }),
      })
    );
  };

  const handleYearChange = (selectedYear) => {
    dispatch(
      updateFiltersStates({
        year: selectedYear,
        sortByDate: isFirstYearChange ? filterDetails.sortByDate : [],
      })
    );

    if (isFirstYearChange) {
      setIsFirstYearChange(false);
    }
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      <div className="content">
        <MainHeading
          title={"Payment Overview"}
          //   buttonText={"Create Payment Ticket"}
          //   buttonLink={userDetails?.designation?.canCreate?.includes("pt") && RoutesLink?.create_against_po}
          //   buttonIcon={<PlusIcon />}
          dateChangeHandler={dateChangeHandler}
          handleYearChange={handleYearChange}
        />
        <Nav tabs className="nav nav-tabs border-0 mb-4">
          <NavItem className="nav-item">
            <NavLink
              className={
                ActiveTab === "all"
                  ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2 active"
                  : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2"
              }
              style={{ cursor: "pointer" }}
              onClick={() => toggleTab("all")}
            >
              All
            </NavLink>
          </NavItem>
          <NavItem className="nav-item">
            <NavLink
              className={
                ActiveTab === "overdue"
                  ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-2 active"
                  : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-2"
              }
              style={{ cursor: "pointer" }}
              onClick={() => toggleTab("overdue")}
            >
              Over Due
            </NavLink>
          </NavItem>
          <NavItem className="nav-item ">
            <NavLink
              className={
                ActiveTab === "today"
                  ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0 active"
                  : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0"
              }
              style={{ cursor: "pointer" }}
              onClick={() => toggleTab("today")}
            >
              Today
            </NavLink>
          </NavItem>
          <NavItem className="nav-item ">
            <NavLink
              className={
                ActiveTab === "tomorrow"
                  ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0 active"
                  : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0"
              }
              style={{ cursor: "pointer" }}
              onClick={() => toggleTab("tomorrow")}
            >
              Tomorrow
            </NavLink>
          </NavItem>
          <NavItem className="nav-item ">
            <NavLink
              className={
                ActiveTab === "completed"
                  ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end- border-start-0 active"
                  : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
              }
              style={{ cursor: "pointer" }}
              onClick={() => toggleTab("completed")}
            >
              Completed
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={ActiveTab}>
          <TabPane tabId={"all"}>
            <Fade in={ActiveTab === "all"} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    handleSearch={handleSearchChange}
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    isShowVendorFilter={ActiveTab === "all"}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    getSite={GetSiteList}
                    getCompany={GetCompanyList}
                  />
                  <CommonTable
                    TableHeading={TableHeading}
                    TableData={pageStates?.paymentTicketList}
                    ActionData={ActionData}
                    currentPage={filterDetails?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={filterDetails?.totalPages}
                    count={filterDetails?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={filterDetails.pageSize}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
          <TabPane tabId={"overdue"}>
            <Fade in={ActiveTab === "overdue"} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    handleSearch={handleSearchChange}
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    isShowVendorFilter={ActiveTab === "overdue"}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    getSite={GetSiteList}
                    getCompany={GetCompanyList}
                  />
                  <CommonTable
                    TableHeading={TableHeading}
                    TableData={pageStates?.paymentTicketList}
                    ActionData={ActionData}
                    currentPage={filterDetails?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={filterDetails?.totalPages}
                    count={filterDetails?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={filterDetails.pageSize}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
          <TabPane tabId={"today"}>
            <Fade in={ActiveTab === "today"} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    handleSearch={handleSearchChange}
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    isShowVendorFilter={ActiveTab === "today"}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    getSite={GetSiteList}
                    getCompany={GetCompanyList}
                  />
                  <CommonTable
                    TableHeading={TableHeading}
                    TableData={pageStates?.paymentTicketList}
                    ActionData={ActionData}
                    currentPage={filterDetails?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={filterDetails?.totalPages}
                    count={filterDetails?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={filterDetails.pageSize}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
          <TabPane tabId={"tomorrow"}>
            <Fade in={ActiveTab === "tomorrow"} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    handleSearch={handleSearchChange}
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    isShowVendorFilter={ActiveTab === "tomorrow"}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    getSite={GetSiteList}
                    getCompany={GetCompanyList}
                  />
                  <CommonTable
                    TableHeading={TableHeading}
                    TableData={pageStates?.paymentTicketList}
                    ActionData={ActionData}
                    currentPage={filterDetails?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={filterDetails?.totalPages}
                    count={filterDetails?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={filterDetails.pageSize}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
          <TabPane tabId={"completed"}>
            <Fade in={ActiveTab === "completed"} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    handleSearch={handleSearchChange}
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    isShowVendorFilter={ActiveTab === "completed"}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    getSite={GetSiteList}
                    getCompany={GetCompanyList}
                  />
                  <CommonTable
                    TableHeading={TableHeading}
                    TableData={pageStates?.paymentTicketList}
                    ActionData={ActionData}
                    currentPage={filterDetails?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={filterDetails?.totalPages}
                    count={filterDetails?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={filterDetails.pageSize}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
        </TabContent>
      </div>
      <ConfirmModal
        modal={modal}
        toggle={() => toggleModal()}
        submitHandler={HandleDelete}
        isLoading={isLoading}
      />
    </>
  );
}
